import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { AppContext } from '../../contexts/AppContext';
import { Oem } from '../../models/ApiModels';
import { SettingsTabs } from './SettingsTabs';

export function Settings() {
  const [currentTab, setCurrentTab] = useState('Administration');
  const { currentOem, currentOemTenantId, representingOem, isBusinessCustomer, isHumphreeUser } =
    useContext(AppContext);
  const oems = useSelector((state: any) => state.oems.data);
  const selectedOem = oems.find((oem: Oem) => oem.id === currentOemTenantId)?.name;
  const parentOem = oems.find((oem: Oem) => oem.id === representingOem?.parentOEMTenantId);

  return (
    <div>
      <h1 className='flex flex-wrap items-center mb-10 md:prose-heading4 2xl:prose-heading3 gap-1'>
        {/* showing parent in breadcrumb (only shows for humphree users) */}
        {parentOem && representingOem && (
          <>
            <span>{parentOem?.name}</span>
            <FontAwesomeIcon icon={faChevronRight} />
          </>
        )}
        {currentOemTenantId === '12345678-1234-1234-1234-123456789000' ? 'Humphree' : selectedOem || currentOem?.name}{' '}
        settings
      </h1>
      <SettingsTabs currentTab={currentTab} changeTab={(value: string) => setCurrentTab(value)} />
      <Outlet />
    </div>
  );
}
